/**
 * @file PickingItemsSearch.tsx
 * @description Поле поиска по позициям закрытого или чужого задания
 * (phase19.24 этап 1, шаг 1).
 *
 * У закрытого документа правой панели нет (правило §5.2), но список позиций
 * остаётся длинным, и искать по нему нужно. Поэтому то же самое поле стоит
 * над таблицей — блок `DocumentToolbar` общего каркаса.
 *
 * Подпись под полем берётся из реестра `PICKING_LOCK_HINT`: у закрытого,
 * чужого и «нет права» причины разные, а раньше во всех трёх случаях писали
 * «Задание закрыто».
 */

import { PICKING_LOCK_HINT, type PickingLockReason } from "./picking-item-texts";
import { ScanField, type ScanFieldHandle } from "../../ui/ScanField";
import { WmsFieldLabel } from "../WmsFieldLabel";

interface Props {
  /** Почему отметка недоступна — подпись под полем. */
  lockReason: PickingLockReason;
  busy: boolean;
  scanRef: React.RefObject<ScanFieldHandle | null>;
  onQueryChange: (value: string) => void;
  onSubmitScan: (code: string, fromScanner: boolean) => void;
}

export function PickingItemsSearch({
  lockReason,
  busy,
  scanRef,
  onQueryChange,
  onSubmitScan,
}: Props) {
  return (
    <WmsFieldLabel label="Поиск по позициям" className="hidden lg:block">
      <ScanField
        ref={scanRef}
        mode="scanAndSearch"
        busy={busy}
        helperText={PICKING_LOCK_HINT[lockReason]}
        onQueryChange={onQueryChange}
        onSubmit={(code, meta) => onSubmitScan(code, meta.fromScanner)}
      />
    </WmsFieldLabel>
  );
}
